/* tslint:disable */
type DiscardReason =
  'NO_PLAN' |
  'REPURCHASE_PLAN';
module DiscardReason {
  export const NO_PLAN: DiscardReason = 'NO_PLAN';
  export const REPURCHASE_PLAN: DiscardReason = 'REPURCHASE_PLAN';
  export function values(): DiscardReason[] {
    return [
      NO_PLAN,
      REPURCHASE_PLAN
    ];
  }
}

export { DiscardReason }